export default __webpack_public_path__ + "static/media/Group1497@3x.9f766a81.png";